import { useEffect, useRef, useState } from "react";

type WlpFormStatusType = "success" | "error";

interface WlpFormStatus {
  message: string;
  type: WlpFormStatusType;
  visible: boolean;
}

const VISIBLE_MS = 4200;
const FADE_OUT_MS = 1000;

export function useWlpFormStatus() {
  const [status, setStatus] = useState<WlpFormStatus>();
  const hideTimer = useRef<ReturnType<typeof setTimeout>>();
  const clearTimer = useRef<ReturnType<typeof setTimeout>>();

  const clearTimers = () => {
    if (hideTimer.current) {
      clearTimeout(hideTimer.current);
      hideTimer.current = undefined;
    }

    if (clearTimer.current) {
      clearTimeout(clearTimer.current);
      clearTimer.current = undefined;
    }
  };

  const clearStatus = () => {
    clearTimers();
    setStatus(undefined);
  };

  const showStatus = (type: WlpFormStatusType, message: string) => {
    clearTimers();
    setStatus({ type, message, visible: true });

    hideTimer.current = setTimeout(() => {
      setStatus((prev) => (prev ? { ...prev, visible: false } : prev));
      clearTimer.current = setTimeout(() => setStatus(undefined), FADE_OUT_MS);
    }, VISIBLE_MS);
  };

  useEffect(() => clearTimers, []);

  return {
    status,
    clearStatus,
    showError: (message: string) => showStatus("error", message),
    showSuccess: (message: string) => showStatus("success", message),
  };
}
